// Shared "SAM is replying" bouncing-dot indicator — used by the chat thread's bubble
// (ChatThread.tsx) and the workspace reply strip (UXView.tsx). `dotClassName` carries the size
// and color so each caller keeps its existing look.
export function TypingDots({ dotClassName = 'w-2 h-2 bg-brand-dark' }: { dotClassName?: string }) {
  return (
    <span className="inline-flex items-center gap-1">
      <span className={`${dotClassName} rounded-full animate-bounce [animation-delay:0ms]`} />
      <span className={`${dotClassName} rounded-full animate-bounce [animation-delay:150ms]`} />
      <span className={`${dotClassName} rounded-full animate-bounce [animation-delay:300ms]`} />
    </span>
  );
}
